import { filter, map, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IHomeRepository } from '../../../domain/repository/home.respository';
import { Home } from '../../../domain/entity/home.entity';
import { HomeRequest } from '../../api-client/home.request';

@UntilDestroy()
export class HomeRepository implements IHomeRepository {
  getHomeFeatures(
    ownerId: number,
    activeProjects?: boolean,
    limit?: number,
  ): Observable<Home> {
    return new HomeRequest.List({
      limit: limit ?? 10,
      ownerId: ownerId,
      activeProjects: activeProjects,
    })
      .call()
      .pipe(
        filter((value) => !!value?.response?.data),
        map((value) => value?.response?.data[0]),
        untilDestroyed(this),
      );
  }
  getHomeFeaturesById(id: number): Observable<Home> {
    return new HomeRequest.GetById({ id: id }).call().pipe(
      filter((value) => !!value?.response?.data),
      map((value) => value?.response?.data[0]),
      untilDestroyed(this),
    );
  }
}
